var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCouple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F7C9AB;}\n\t.st1{fill:#F3AB7D;}\n\t.st2{fill:#DB3429;}\n\t.st3{fill:#E25D55;}\n\t.st4{fill:#B3271E;}\n\t.st5{fill:#57130F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4380_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,433.3V507h135v-37.1c0-29.6,16-56.9,42-71.4v0c13-7.6,24.5-18.8,31.9-32.4l30.8-57    l11.3-48c0,0-11.8-1.6-24.2,4.9L480,214l-32-55c-10.9,0-18.9,9-18.9,18.9c0,2.7,0.6,5.5,1.9,8.2l14.1,29.4l-3,45.7l-12.5-56.7    L397,145c-11.1,0-19.3,9.1-19.3,19.3c0,2.3,0.4,4.6,1.3,6.9l18,47.3c0,0,0.5,41.9,0.5,43c0-1.2-16-45.5-16-45.5L350,159    c-11.3,1.8-18.7,11.5-18.7,21.9c0,3.6,0.9,7.2,2.7,10.6L354,228l-1,35l-13,3.5l-7.4-43.4l-35.2-51.3c-7.7,5.6-11.8,14.3-11.8,23.2    c0,5.5,1.6,11,4.8,15.9L303,230l2.5,44.5C296,322,256,328,256,433.3",
    id: "XMLID_4403_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M481.6,244c0,0-24.9,4-30.6,16.3c-5.7,12.3-24.3,35.5-45,44.8c-65,3-67.7,55.2-70,58    c33.5-43,81-35,81-35s32-15,47-42.8c5.3-9.8,12.1-15.6,18.8-19.1L481.6,244L481.6,244z",
    id: "XMLID_4402_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.1,277.4l13.6-6.3l12-3.2l43.9-1.6L442,266h18v-10h-18l-44.5,0.4c0,0-0.1,0-0.1,0    l-44.5,1.6c-0.4,0-0.8,0.1-1.1,0.2l-13,3.5c-0.3,0.1-0.5,0.2-0.8,0.3l-14,6.5L328.1,277.4L328.1,277.4z",
    id: "XMLID_4401_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,433.3c0,0,51,59.7,135,59.7v14H256V433.3L256,433.3z",
    id: "XMLID_4400_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,433.3V507H121v-37.1c0-29.6-16-56.9-42-71.4v0c-13-7.6-24.5-18.8-31.9-32.4l-30.8-57    L5,261.2c0,0,11.8-1.6,24.2,4.9L32,214l32-55c10.9,0,18.9,9,18.9,18.9c0,2.7-0.6,5.5-1.9,8.2L67,215.5l3,45.7l12.5-56.7L115,145    c11.1,0,19.3,9.1,19.3,19.3c0,2.3-0.4,4.6-1.3,6.9l-18,47.3c0,0-0.5,41.9-0.5,43c0-1.2,16-45.5,16-45.5l31.5-57    c11.3,1.8,18.7,11.5,18.7,21.9c0,3.6-0.9,7.2-2.7,10.6L158,228l1,35l13,3.5l7.4-43.4l35.2-51.3c7.7,5.6,11.9,14.3,11.9,23.2    c0,5.5-1.6,11-4.8,15.9L209,230l-2.5,44.5C216,322,256,328,256,433.3",
    id: "XMLID_4399_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.2,266c6.7,3.5,13.5,9.4,18.8,19.1C63,313,95,328,95,328s47.5-8,81,35    c-2.3-2.8-5-55-70-58c-20.8-9.3-39.3-32.5-45-44.8C55.3,248,30.4,244,30.4,244L29.2,266L29.2,266z",
    id: "XMLID_4398_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M183.9,277.4l-13.6-6.3l-12-3.2l-43.9-1.6L70,266H52v-10h18l44.5,0.4c0,0,0.1,0,0.1,0    l44.5,1.6c0.4,0,0.8,0.1,1.1,0.2l13,3.5c0.3,0.1,0.5,0.2,0.8,0.3l14,6.5L183.9,277.4L183.9,277.4z",
    id: "XMLID_4397_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256,80.4c-41.7-106.9-150-100.3-150,21C106,222.7,256,305,256,305s150-82.3,150-203.6    C406-19.9,297.7-26.5,256,80.4",
    id: "XMLID_4396_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,433.3c0,0-51,59.7-135,59.7v14h135V433.3L256,433.3z",
    id: "XMLID_4395_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M172.4,28.2c19.6,6.5-5.3,24.1-13.7,44.9c-5.8,14.3,0.1,42-17.9,40.8    c-18-1.1-13.8-35.1-4.4-56C145.7,37.1,161.2,24.5,172.4,28.2",
    id: "XMLID_4394_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M357,7.5c-1.1,112.6-76.3,207.4-179.2,238.1C216.3,283.2,256,305,256,305    s150-82.3,150-203.6C406,47.3,384.5,16.1,357,7.5",
    id: "XMLID_4393_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4896_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2033_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M156,512h-35c-2.8,0-5-2.2-5-5v-37.1c0-27.8-15-53.4-39.3-67c-14.3-8-26.1-19.9-33.9-34.4     l-30.9-57c-0.2-0.4-0.4-0.8-0.5-1.2l-11.3-48c-0.3-1.4-0.1-2.8,0.7-4c0.8-1.2,2-1.9,3.4-2.1c1.3-0.2,31.6-4,48.1,26.6     c12.4,23,37.5,37,43.5,40c9.2-1.1,52.3-3.7,84.1,37.1l-7.9,6.1c-31.2-40-74.4-33.4-76.2-33.1c-1,0.2-2,0-2.9-0.4     c-1.4-0.6-33.7-16-49.3-45c-9.3-17.3-24.2-20.9-32.3-21.5l9.7,41.3l30.6,56.4c6.9,12.8,17.3,23.3,30,30.4     c27.4,15.3,44.4,44.4,44.4,75.7V502h30V512z",
    id: "XMLID_4354_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2032_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M256,512h-80v-10h75v-68.7c0-66.4-16-92.1-30.2-114.9c-8.1-12.9-15.7-25.2-19.2-43     c-0.1-0.4-0.1-0.8-0.1-1.3l0.2-2.8l10,0.6l-0.1,2.1c3.3,15.7,10,26.5,17.8,39C244.2,337,261,364.1,261,433.3V507     C261,509.7,258.8,512,256,512z",
    id: "XMLID_4353_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1942_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M172,271.5c-0.4,0-0.9-0.1-1.3-0.2l-13-3.5c-2.1-0.6-3.6-2.5-3.7-4.7l-1-35     c0-0.9,0.2-1.8,0.6-2.5l1.2-2.1l8,4.4l0.2,0l0,0.1l0.5,0.3l-0.5,0.9l0.9,29.9l4.1,1.1l2.9-17.1l9.9,1.7l-3.9,22.5     c-0.2,1.4-1,2.6-2.2,3.4C173.9,271.2,172.9,271.5,172,271.5z",
    id: "XMLID_4352_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1946_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M114.5,266.5L114.5,266.5c-2.8,0-5-2.3-5-5c0-0.1,0-0.1,0-0.2c0-2.1,0.3-28.7,0.5-42.8     c0-0.6,0.1-1.2,0.3-1.7l13.6-35.6l9.3,3.6L120,219.4l-0.1,11.4c1.7-4.7,3.7-10.2,5.9-16.5c0.1-0.2,0.2-0.5,0.3-0.7l8.8-15.9     l8.8,4.8l-8.6,15.5c-5.8,16-15,42-15.7,44.4c0,0,0.1-0.4,0.1-1h0C119.2,266.5,114.6,266.5,114.5,266.5z",
    id: "XMLID_4351_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_798_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M34.2,266.3l-10-0.5l2.8-52.1c0-0.8,0.3-1.6,0.7-2.2l32-55c0.9-1.5,2.5-2.5,4.3-2.5     c8.3,0,15.8,4.2,20.2,11.2c4.4,7,4.9,15.6,1.3,23.1l-0.8,1.7l24.2-44.4l8.8,4.8l-30.5,55.9l-12.3,56c-0.5,2.4-2.8,4.1-5.3,3.9     c-2.5-0.2-4.4-2.2-4.6-4.7l-3-45.7c-0.1-0.9,0.1-1.7,0.5-2.5l14.1-29.4c2.1-4.3,1.8-9.4-0.8-13.4c-2.1-3.3-5.3-5.5-9-6.2     l-29.8,51.2L34.2,266.3z M72.1,216.5l0.6,9.3l4.3-19.7L72.1,216.5z",
    id: "XMLID_4348_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_797_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M183.9,277.4l-13.6-6.3l-12-3.2l-43.9-1.5L70,266H52v-10h18l44.5,0.4c0,0,0.1,0,0.1,0     l44.5,1.6c0.4,0,0.8,0.1,1.1,0.2l13,3.5c0.3,0.1,0.5,0.2,0.8,0.3l14,6.5L183.9,277.4z",
    id: "XMLID_4333_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1968_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M391,512H256c-2.8,0-5-2.2-5-5v-73.7c0-69.2,16.8-96.3,31.7-120.2     c7.8-12.5,14.5-23.4,17.8-39l-0.1-2.1l10-0.6l0.2,2.8c0,0.4,0,0.8-0.1,1.3c-3.6,17.8-11.2,30-19.2,43     C277,341.2,261,366.9,261,433.3V502h125v-32.1c0-31.4,17-60.4,44.4-75.7c12.7-7.1,23.1-17.6,30-30.4l30.6-56.4l9.8-41.3     c-8.1,0.6-22.9,4.1-32.3,21.5c-15.6,29-47.9,44.3-49.3,45c-0.9,0.4-2,0.6-3,0.4c-1.8-0.3-45.1-6.9-76.2,33.1l-7.9-6.1     c31.7-40.7,74.9-38.2,84.1-37.1c5.9-3.1,31.1-17.1,43.5-40c16.5-30.5,46.8-26.8,48.1-26.6c1.4,0.2,2.6,1,3.4,2.1     c0.8,1.2,1.1,2.6,0.7,4l-11.3,48c-0.1,0.4-0.3,0.8-0.5,1.2l-30.9,57c-7.8,14.5-19.6,26.4-33.9,34.4c-24.2,13.6-39.3,39.2-39.3,67     V507C396,509.7,393.8,512,391,512z",
    id: "XMLID_4332_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1967_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M340,271.5c-0.9,0-1.9-0.3-2.7-0.8c-1.2-0.8-2-2-2.2-3.4l-3.9-22.5l9.9-1.7l2.9,17.1     l4.1-1.1l0.9-29.9l-0.5-0.9l0.5-0.3l0-0.1l0.2,0l8-4.4l1.2,2.1c0.4,0.8,0.6,1.7,0.6,2.5l-1,35c-0.1,2.2-1.6,4.1-3.7,4.7l-13,3.5     C340.9,271.4,340.4,271.5,340,271.5z",
    id: "XMLID_4331_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1958_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M397.5,266.5c-0.1,0-4.7,0-5-5h0c0,0.6,0.1,1,0.1,1c-0.6-2.5-9.9-28.4-15.7-44.4l-8.6-15.5     l8.8-4.8l8.8,15.9c0.1,0.2,0.2,0.5,0.3,0.7c2.3,6.3,4.2,11.8,5.9,16.5l-0.1-11.4l-13.3-34.8l9.3-3.6l13.6,35.6     c0.2,0.6,0.3,1.1,0.3,1.7c0.2,14.1,0.5,40.8,0.5,42.8c0,0.1,0,0.1,0,0.2C402.5,264.2,400.3,266.5,397.5,266.5L397.5,266.5z",
    id: "XMLID_4330_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1948_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M477.8,266.3l-2.7-50.8l-29.8-51.2c-3.7,0.7-7,2.9-9,6.2c-2.6,4.1-2.9,9.1-0.8,13.4     l14.1,29.4c0.4,0.8,0.5,1.6,0.5,2.5l-3,45.7c-0.2,2.5-2.1,4.5-4.6,4.7c-2.5,0.2-4.7-1.5-5.3-3.9l-12.3-56l-19.6-35.9l8.8-4.8     l13.3,24.4l-0.8-1.7c-3.6-7.5-3.1-16.1,1.3-23.1c4.4-7,12-11.2,20.2-11.2c1.8,0,3.4,0.9,4.3,2.5l32,55c0.4,0.7,0.6,1.5,0.7,2.2     l2.8,52.1L477.8,266.3z M435,206.1l4.3,19.7l0.6-9.3L435,206.1z",
    id: "XMLID_4327_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_795_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M327.9,277.4l-4.2-9.1l14.1-6.5c0.3-0.1,0.5-0.2,0.8-0.3l13-3.5c0.4-0.1,0.7-0.2,1.1-0.2     l44.5-1.6c0,0,0.1,0,0.1,0L442,256h20v10h-20l-44.4,0.4l-43.9,1.5l-12.1,3.2L327.9,277.4z",
    id: "XMLID_4326_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_794_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M256,310c-0.8,0-1.7-0.2-2.4-0.6c-1.6-0.9-38.5-21.3-76-57.1     c-22.1-21.1-39.8-43.1-52.5-65.5c-16-28.2-24.1-56.9-24.1-85.5c0-65.8,30.6-95,59.2-100.4c30.6-5.7,71,12.9,95.8,66.6     C280.8,13.9,321.2-4.7,351.8,1C380.4,6.4,411,35.6,411,101.4c0,28.5-8.1,57.3-24.1,85.5c-12.7,22.3-30.3,44.4-52.5,65.5     c-37.5,35.8-74.5,56.2-76,57.1C257.7,309.8,256.8,310,256,310z M171.2,10c-3.1,0-6.2,0.3-9.1,0.8c-31.5,5.9-51,40.6-51,90.5     c0,60.8,39.9,111.6,73.3,143.5c31.3,29.8,62.9,49.2,71.7,54.3c8.8-5.2,40.5-24.5,71.7-54.3C361.1,213,401,162.2,401,101.4     c0-49.9-19.6-84.6-51-90.5c-28.5-5.4-67.2,14.6-89.3,71.3c-0.7,1.9-2.6,3.2-4.7,3.2s-3.9-1.3-4.7-3.2     C231.5,31.3,198.4,10,171.2,10z",
    id: "XMLID_4323_"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCouple);
export default __webpack_public_path__ + "static/media/icon-couple.4d3bf69bb8b08f61ba8eb3b4211da541.svg";
export { ForwardRef as ReactComponent };